import { makeElementClassNameFactory, makeRootClassName } from '@shared/utils';
import { ScheduleStop } from 'clerk_common/types';
import moment from 'moment-timezone';

const ROOT = makeRootClassName('ShipmentCard');
const el = makeElementClassNameFactory(ROOT);

export function ApptStatusChip({ stop }: { stop: ScheduleStop }) {
  const status = stop.appointmentStatus;
  if (!status) return null;

  const requestedDt = stop.appointmentRequestedDt;
  const confirmedDt = stop.appointmentConfirmedDt;
  const confirmationNumber = stop.appointmentConfirmationNumber;
  return (
    <div className="mt-1">
      <div className={`${el`appt-status-chip`} status-${status}`}>
        Appointment {titleCase(status)}
      </div>
      {requestedDt && (
        <div className="mt-1 text-xs">
          <i>Requested {formatTime(stop, requestedDt)}</i>
        </div>
      )}
      {confirmedDt && (
        <div className="mt-1 text-xs">
          <i>Confirmed {formatTime(stop, confirmedDt)}</i>
          <br />
          {confirmationNumber && <i>Confirmation: {confirmationNumber}</i>}
        </div>
      )}
    </div>
  );
}

function titleCase(str: string) {
  return str
    .toLowerCase()
    .split(' ')
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
}

function formatTime(stop: ScheduleStop, dt: Date) {
  const timezone = stop.placeTimeZone;
  return moment.tz(dt, timezone).format('h:mma on M/D');
}
